<script setup>
import { useI18n } from 'vue-i18n';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col w-full max-w-2xl min-w-0">
    <BaseSettingsHeader
      :title="t('GENERAL_SETTINGS.WHATSAPP_FEES_PAGE.TITLE')"
      :description="t('GENERAL_SETTINGS.WHATSAPP_FEES_PAGE.DESCRIPTION')"
    />
  </div>
</template>
